import { Injectable } from '@angular/core';
import { MessageVideoCallInfo } from '../../../../../models/message-video-call'

@Injectable({
  providedIn: 'root'
})
export class VideoCallMessageService {

  constructor() { }

  targetVideoCallInfo: MessageVideoCallInfo = null
  targetVideoCallCaller: string

  initTargetVideoCallInfo(): void {
    this.targetVideoCallInfo = null
  }

  storeTargetVideoCallInfo(vcInfo: MessageVideoCallInfo): void {
    this.targetVideoCallInfo = vcInfo
  }

  storeCaller(caller: string): void {
    this.targetVideoCallCaller = caller
  }
}
